import { LootboxModal } from '@/components/modals/LootboxModal';
import { useGetCommonStore } from '@/store';

export const useLootboxModal = () => {
  const useCommonStore = useGetCommonStore();

  const activeLootboxId = useCommonStore.use.activeLootboxId();

  return activeLootboxId ? <LootboxModal lootboxId={activeLootboxId} /> : null;
};
